import "packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/byok/index.css.ts.vanilla.css!=!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/desktop/dialogs/setting/workspace-setting/byok/index.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA8VY3W6jOBS-71NYqlZqpboyBNKU3u2bGGzAM2B7bJOQWe27r7ADMYQ0hVSzFyiJf8453_n7Dnll-6jWvxD45wEAwrSs8DEBeUXbjwdgPyFhimaGCZ6ATFRNzbudAssEhJFsPx7-fXh1QgIrJBWKUJWAQLZAi4oRsMfqCUKc54xTuA9hhY9UQcY1I_Rvexq6S88fw32oMGGNTsBOWkvEnqq8EocElIwQam1IcfazUKLhJLmi43wCSsVqrI7Pnr3hPGhcsYJDZmitE5BRbqjqln802rD8CDPBDeUmAVrijMKUmgOlZ58EoTNYYkIYL9wCCLZuNe3hGiPqtT4aAGwsgFxwAzX7TSdecOu1dar9fqCsKE0Ctgh1a5mohLr0nKGtmfNWdFtZq62yqlsoT8pC5JB_pk3TTHAy0RcvTckrcbNRiSZBCXeyHUyzNtjb53uDGdtlZgz33sb3CsWItUYxAg2tZYUNhe6WdpUEglwB3BhxC8yfTLG3pMLawKxkFfHKexCPvLM7e-AKwk3oEHrn3-15IXHGzDEB6DXaLS7r2dTB9xX2eevAiCn7PgfAkNPRyNV9q9ouy_TvQJpapFc0po0xgnu1PNb4mKP8Lc89aZmVdgLd51MP2v0ezpJp8OL4eyDRzyDNODFrlO6OFgqnN6s5t8JrxuEJpe2ES3lvTHvFomyzAk6kNrXjD3Xy0oVuhlHtjfMGrSomNdO2FEpmKLSclwAuDgrLmyaf-GBx62ef9NxOcQJ69dab48T84bepvjTf39-nDCDbPgwehiBwSyMKC_6Hwv7pV8FjGoWb4KI5PuZ5Huexd6tamYqDgHrOebsZuvn4jknvbi_xVWNrH89zLsz38xPu1Wbe66EBplgHMxyFVq4SMmG-Da09kb-syH7PjS7DpvryvLi4P-h1o2iwWzmKmhHOzSn9e55E6C8X67azxibUMCR9llZ3Vs-QvQgE6KKRXeWP8XAerkhxf574GvMAIBrTKe6Yg1Pfs0kiK5zRUlSEqpvM750dxSfJRdZov3ctGIm6uJWYdISHZDs8HUGoIsVPG_QCghi9gHATvwD0ukG-7ua-WdOWH-XkYjTAqmAcGnHRovduhHH7yi-9r5TEIOYwSzDDdjvaDrY7HPvbx0VvN4pKio11ZM14jdunSLYv3dvA8_OFs3xnTLpPEKEpFW1Pbz7T_yJ-D4PekOuzPb577-oe5CawEb3G6Y7Qbj7-D68Ne4AlEQAA\"}!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var bar = 'iv4msqz';
export var capabilityIcon = 'iv4msqa';
export var capabilityIconActive = 'iv4msqb';
export var capabilityIconSvg = 'iv4msqc';
export var capabilityRow = 'iv4msq8';
export var capabilityRowInactive = 'iv4msq9';
export var chart = 'iv4msqy';
export var dangerTag = 'iv4msqk';
export var description = 'iv4msq4';
export var dragHandle = 'iv4msqe';
export var empty = 'iv4msq5';
export var endpointField = 'iv4msqq iv4msqp';
export var error = 'iv4msqw';
export var field = 'iv4msqp';
export var fieldHint = 'iv4msqs';
export var form = 'iv4msqo';
export var input = 'iv4msqt';
export var label = 'iv4msqr';
export var locked = 'iv4msqn';
export var modalActions = 'iv4msqu';
export var notice = 'iv4msqm';
export var panel = 'iv4msq1';
export var panelHeader = 'iv4msq2';
export var row = 'iv4msq7';
export var rowActions = 'iv4msql';
export var rowDescription = 'iv4msqh';
export var rowDisabled = 'iv4msqd';
export var rowMain = 'iv4msqf';
export var rowTitle = 'iv4msqg';
export var rows = 'iv4msq6';
export var stack = 'iv4msq0';
export var success = 'iv4msqx';
export var tag = 'iv4msqj';
export var tags = 'iv4msqi';
export var testStatus = 'iv4msqv';
export var title = 'iv4msq3';